import React from "react";
import {Button, Form} from "react-bootstrap";

class EditBookMetaData extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
        data:{
            book_title: props.books.book_title,
            book_description: props.books.book_description,
            total_chapters: props.books.total_chapters
        },
        old_book_title: props.books.book_title,
        old_book_description: props.books.book_description,
        old_total_chapters: props.books.total_chapters
      };
    };
    onsubmit=e=>{
        e.preventDefault();
    };
    chBookTitle=e=>{
        this.props.chBookTitle(this.state.data.book_title);
        const {book_title} = this.state.data;
        this.setState({old_book_title: book_title})
    };
    chBookDescription=e=>{
        this.props.chBookDescription(this.state.data.book_description);
        const {book_description} = this.state.data;
        this.setState({old_book_description: book_description})
    };
    chTotalChapters=e=>{
        this.props.chTotalChapters(this.state.data.total_chapters);
        const {total_chapters} = this.state.data;
        this.setState({old_total_chapters: total_chapters})
    };
    onchange = event => this.setState({
        data: {...this.state.data, [event.target.name] : event.target.value }
    });
    render(){
        const {old_book_title, old_book_description, old_total_chapters} = this.state;
        const {book_title, book_description, total_chapters} = this.state.data;
        const {onchange, onsubmit, chBookTitle, chBookDescription, chTotalChapters} = this;
        return(
            <div className="form_comn">
                <form onSubmit={onsubmit}>
                    <div>
                        <label htmlFor="book_title">Book Title: </label>
                        <input 
                           type="text" 
                           className="form-control"
                           value={book_title}
                           name="book_title"
                           id="book_title"
                           onChange={onchange}
                           autoComplete="off"
                        /><br/>
                        {book_title !== old_book_title && (
                            <Button variant="success" onClick={chBookTitle}>Change Book Title</Button>
                        )}
                    </div>
                    <div>
                        <label htmlFor="book_description">Book Description: </label>
                        <textarea
                           className="form-control"
                           value={book_description}
                           name="book_description"
                           id="book_description"
                           onChange={onchange}
                           autoComplete="off"
                        /><br/>
                        {book_description !== old_book_description && (
                            <Button variant="success" onClick={chBookDescription}>Change Book Description</Button>
                        )}
                    </div>
                    <Form.Group>
                        <Form.Label>Select Book Type:</Form.Label>
                        <Form.Control as="select" name="book_type" onChange={this.onchange} value="PDF">
                          <option>PDF</option>
                          <option value="PDF">HTML</option>
                        </Form.Control>
                        <Form.Text className="htmlnimp">**HTML Feature is not implemented</Form.Text> 
                    </Form.Group>
                    <div>
                        <label htmlFor="total_chapters">Total Chapters: </label>
                        <input 
                            type="number" 
                            id="total_chapters" 
                            value={total_chapters}
                            className="form_control_c"
                            name="total_chapters"
                            onChange={onchange}
                            required
                        /><br/>
                        {total_chapters !== old_total_chapters && (
                            <Button variant="success" onClick={chTotalChapters}>Change Total Chapters</Button>
                        )}
                    </div><br/>
                </form>
            </div>
        );
    };
};

export default EditBookMetaData;